export default __webpack_public_path__ + "static/media/timetable_img.fb376e67.png";